module.exports = __webpack_public_path__ + "img/intro_title_2.1a8a5864.png";